import Vue from 'vue'
import Router from 'vue-router'
// import Index from '@/views/frontent/pc'

Vue.use(Router)
const routes = [
  {
    path: '/',
    name: 'judge',
    component: () => import('@/views/frontent/judge')
  },
  // PC端
  {
    path: '/pc',
    name: 'pcIndex',
    component: () => import('@/views/frontent/pc')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test')
  },
  {
    path: '/pc/layout',
    name: 'layout',
    component: () => import('@/views/frontent/pc/layout')
  },
  {
    path: '/pc/introduce',
    name: 'introduce',
    component: () => import('@/views/frontent/pc/layout/introduce')
  },
  {
    path: '/pc/comdetail',
    name: 'comdetail',
    component: () => import('@/views/frontent/pc/comdetail')
  },

  {
    path: '/pc/comnews',
    name: 'news',
    component: () => import('@/views/frontent/pc/comnews')
  },
  {
    path: '/pc/newsdetail',
    name: 'newsdetail',
    component: () => import('@/views/frontent/pc/comnews/newsdetail')
  },

  {
    path: '/pc/partyaccess',
    name: 'partyaccess',
    component: () => import('@/views/frontent/pc/partyaccess')
  },
  // 红春晚视频详情页
  {
    path: '/pc/redspring',
    name: 'redspring',
    component: () => import('@/views/frontent/pc/partyaccess/components/redspringvideo')
  },
  {
    path: '/pc/digitization',
    name: 'digitization',
    component: () => import('@/views/frontent/pc/digitization')
  },
  {
    path: '/pc/construction',
    name: 'construction',
    component: () => import('@/views/frontent/pc/construction')
  },
  // 举报页面
  {
    path: '/pc/report',
    name: 'report',
    component: () => import('@/views/frontent/pc/construction/report')
  },
  // 举报成功跳转页面
  {
    path: '/pc/reportsuccess',
    name: 'reportsuccess',
    component: () => import('@/views/frontent/pc/construction/reportsuccess')
  },
  {
    path: '/pc/recruitdetail',
    name: 'recruitdetail',
    component: () => import('@/views/frontent/pc/recruitment/recruitdetail')
  },
  {
    path: '/pc/excellent',
    name: 'excellent',
    component: () => import('@/views/frontent/pc/recruitment/excellent')
  },
  // 社会招聘跳转到别的页面
  // 校园招聘
  {
    path: '/pc/campus',
    name: 'campus',
    component: () => import('@/views/frontent/pc/recruitment/campus')
  },
  {
    path: '/pc/recruitment',
    name: 'recruitment',
    component: () => import('@/views/frontent/pc/recruitment/index')
  },
  // 联系我们
  {
    path: '/pc/contactus',
    name: 'contactus',
    component: () => import('@/components/ContactUs')
  },
  // 隐私保护
  {
    path: '/pc/secret',
    name: 'secret',
    component: () => import('@/components/Secret')
  },
  // 法律声明
  {
    path: '/pc/law',
    name: 'law',
    component: () => import('@/components/Law')
  },

  /* 手机端路由 */
  {
    path: '/mob',
    name: 'mobIndex',
    component: () => import('@/views/frontent/mob/index')
  },
  // 走进大汉
  {
    path: '/mob/comdetail',
    name: 'mobComdetail',
    component: () => import('@/views/frontent/mob/comdetail')
  },
  // 新闻中心
  {
    path: '/mob/comnews',
    name: 'mobComnews',
    component: () => import('@/views/frontent/mob/comnews')
  },
  {
    path: '/mob/newsdetail',
    name: 'newsdetail',
    component: () => import('@/views/frontent/mob/comnews/newsdetail')
  },
  // 产业中心
  {
    path: '/mob/layout',
    name: 'mobLayout',
    component: () => import('@/views/frontent/mob/layout')
  },
  {
    path: '/mob/introduce',
    name: 'mobIntroduce',
    component: () => import('@/views/frontent/mob/layout/introduce')
  },
  // 数字大汉
  {
    path: '/mob/components',
    name: 'mobComponents',
    component: () => import('@/views/frontent/mob/digitization/components/detail')
  },
  // 数字大汉详情页
  {
    path: '/mob/digitization',
    name: 'mobDigitization',
    component: () => import('@/views/frontent/mob/digitization')
  },
  // 党群文化
  {
    path: '/mob/partyaccess',
    name: 'mobpartyaccess',
    component: () => import('@/views/frontent/mob/partyaccess')
  },
  // 红春晚视频详情页
  {
    path: '/mob/redspring',
    name: 'mobredspring',
    component: () => import('@/views/frontent/mob/partyaccess/components/redspringvideo')
  },
  {
    path: '/mob/recruitment',
    name: 'mobRecruitment',
    component: () => import('@/views/frontent/mob/recruitment')
  },
  {
    path: '/mob/school',
    name: 'school',
    component: () => import('@/views/frontent/mob/recruitment/school')
  },
  {
    path: '/mob/monitor',
    name: 'monitor',
    component: () => import('@/views/frontent/mob/monitor'),
    meta: {
      title: '监察举报'
    }
  },
  {
    path: '/mob/online',
    name: 'online',
    component: () => import('@/views/frontent/mob/monitor/online'),
    meta: {
      title: '在线举报'
    }
  },
  {
    path: '/mob/realInform',
    name: 'realInform',
    component: () => import('@/views/frontent/mob/monitor/realInform'),
    meta: {
      title: '实名举报'
    }
  },
  {
    path: '/mob/anonymity',
    name: 'anonymity',
    component: () => import('@/views/frontent/mob/monitor/anonymity'),
    meta: {
      title: '匿名举报'
    }
  },
  {
    path: '/mob/monitorSuccess',
    name: 'monitorSuccess',
    component: () => import('@/views/frontent/mob/monitor/monitorSuccess'),
    meta: {
      title: '举报成功'
    }
  }
]
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: routes
  // mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js